import React, { useState, useEffect } from "react";
import useCobroExAlumnos from "../hooks/useCobroExAlumnos";
import useValidacionPago from "../hooks/useValidacionPago";
import useHistorialPagos from "../hooks/useHistorialPagos";
import VistaCobroExAlumnos from "./VistaCobroExAlumnos";
import VistaHistorialDePagos from "./VistaHistorialDePagos";
import { rolDeSesion, esAdministrador, puedeValidarPago } from "../utilities/permisos";

// Reutiliza los mismos hooks y la misma pantalla "Historial de Pagos" (ordenes pendientes para validar + pagos hechos)
// que ya usa el alumno normal: ambos endpoints funcionan sobre cualquier codigo_alumno/matricula, sin importar si es
// real o la matricula ficticia generica de ex-alumnos.
const CobroExAlumnos = ({ user, catalogoConceptos }) => {
  const [vistaActual, setVistaActual] = useState("cobro"); // 'cobro' | 'historial'

  // El Administrador puede consultar pendientes de cualquier plantel pero
  // nunca valida pagos; cualquier cajero real (rol 2 o 3) si puede.
  const rolCajero = rolDeSesion();
  const puedeValidar = puedeValidarPago(rolCajero);
  const soloLectura = esAdministrador(rolCajero); // ve los botones de validar, deshabilitados

  const cobroProps = useCobroExAlumnos(user, catalogoConceptos);
  const { referencia } = cobroProps;

  // Representa la referencia generica como si fuera el "alumno seleccionado"
  // que esperan estos hooks (solo usan .matricula).
  const entidadFicticia = referencia ? { matricula: referencia.matricula, nombre: referencia.nombre } : null;

  const { historialPagos, cargandoHistorial, obtenerHistorialAlumno } = useHistorialPagos();
  const validacionProps = useValidacionPago(user?.id_usuario, entidadFicticia, () => {
    if (referencia) obtenerHistorialAlumno(referencia.matricula);
  });

  useEffect(() => {
    if (vistaActual === "historial" && referencia) {
      validacionProps.buscarReferenciasPendientes(referencia.matricula);
      obtenerHistorialAlumno(referencia.matricula);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vistaActual, referencia]);

  if (vistaActual === "historial") {
    return (
      <div style={{ marginTop: "20px" }}>
        <div className="catalogo-section" style={{ marginBottom: "20px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div>
            <h2 style={{ color: "#003366", margin: "0 0 8px 0", fontSize: "22px" }}>Historial de Pagos de Ex-alumnos</h2>
            <p style={{ color: "#666", margin: 0, fontSize: "14px" }}>
              <strong>Plantel:</strong> {user?.nombre_plantel} &nbsp;|&nbsp; <strong>Referencia:</strong> {referencia?.matricula}
            </p>
          </div>
          <button
            className="btn-logout"
            onClick={() => setVistaActual("cobro")}
            style={{ width: "auto", padding: "12px 24px", backgroundColor: "#d9534f" }}
          >
            ← Volver al Cobro
          </button>
        </div>
        <VistaHistorialDePagos
          {...validacionProps}
          cargando={validacionProps.cargandoReferencias || cargandoHistorial}
          pendientes={validacionProps.referenciasPendientes}
          pagos={historialPagos}
          avisos={validacionProps.avisosAlumno}
          puedeValidar={puedeValidar}
          soloLectura={soloLectura}
        />
      </div>
    );
  }

  return (
    <VistaCobroExAlumnos
      {...cobroProps}
      onVerHistorial={() => setVistaActual("historial")}
    />
  );
};

export default CobroExAlumnos;
